<template>
  <v-dialog v-model="dialog" :persistent="true" max-width="600px" style="z-index: 205">
    <v-card>
      <v-card-title>
        <span class="headline">Thêm tin nhắn mẫu</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form1" lazy-validation v-if="dialog">
          <v-container>
            <v-layout column>
              <v-flex cols="12">
                <v-text-field
                  :rules="titleRule"
                  v-model="titleSms"
                  label="Tiêu đề"
                  required
                  validate-on-blur
                ></v-text-field>
              </v-flex>
              <v-flex cols="12">
                <v-textarea
                  :rules="contentRule"
                  v-model="contentSms"
                  label="Nội dung"
                  required
                  validate-on-blur
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-end">
        <div class="flex-grow-1"></div>
        <v-btn color="blue darken-1" dark text @click="addNewPattern()">Lưu</v-btn>
        <v-btn color="blue darken-1" flat dark text @click="close">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    // dialog: {
    //   type: Boolean,
    //   default: false
    // },
    // title: {
    //   type: String,
    //   default: ''
    // },
    // content: {
    //   type: String,
    //   default: ''
    // }
  },
  data () {
    return {
      dialog: false,
      titleSms: '',
      contentSms: '',
      titleRule: [value => !!value || 'Tiêu đề không được để trống'],
      contentRule: [value => !!value || 'Nội dung không được để trống']
    };
  },
  watch: {
  },
  methods: {
    ...mapActions(['NewAvailableMessage', 'GetAvailableMessage']),
    close () {
      this.dialog = false;
    },
    open (data) {
      this.reset();
      if (data) {
        this.titleSms = data.Title;
        this.contentSms = data.Content;
        console.log('data new', data);
      }
      this.dialog = true;
    },
    reset () {
      this.titleSms = '';
      this.contentSms = '';
    },

    async addNewPattern () {
      if (this.titleSms && this.contentSms) {
        const data = {
          Title: this.titleSms,
          Content: this.contentSms
        };
        let res = await this.NewAvailableMessage(data);
        if (res) {
          let resAvailableSms = await this.GetAvailableMessage();
          this.$emit('loadSms', resAvailableSms);
        }
        this.close();
      } else {
        this.$refs.form1.validate();
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/sms/AddNewSms.vue